import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Input, InputPhone, Select } from 'components/fields'

export default class Contact extends Component {
  static propTypes = {
    phoneTypes: PropTypes.array,
    isEmailFixed: PropTypes.bool,
    prefix: PropTypes.string,
    showSecondaryFields: PropTypes.bool,
    isEmailDisabled: PropTypes.bool,
    confirmEmailAddress: PropTypes.bool,
    selectedCountryIcoCode: PropTypes.string,
    showSecondaryEmail: PropTypes.bool,
    showPhoneNumber: PropTypes.bool,
    showPhoneType: PropTypes.bool,
    showSecondaryPhone: PropTypes.bool,
    showSecondaryPhoneType: PropTypes.bool,
    showOtherEmails: PropTypes.bool,
  }

  static defaultProps = {
    prefix: null,
    isEmailFixed: false,
    isEmailDisabled: false,
    confirmEmailAddress: true,
    showSecondaryEmail: true,
    showPhoneNumber: true,
    showPhoneType: true,
    showSecondaryPhone: true,
    showSecondaryPhoneType: true
  }

  render() {
    const {
      isEmailFixed,
      showOtherEmails,
      showSecondaryFields,
      isEmailDisabled,
      confirmEmailAddress,
      selectedCountryIcoCode,
      showSecondaryEmail,
      showPhoneNumber,
      showPhoneType,
      showSecondaryPhone,
      showSecondaryPhoneType,
    } = this.props
    const prefix = this.props.prefix && this.props.prefix.length > 0
      ? `${this.props.prefix}.`
      : ''

    return (
      <div>

          <div className='row'>
            <div className='col-xs-12 col-md-4'>
              <Input
                name={`${prefix}email`}
                label='Email'
                intlKey='label.email'
                disabled={isEmailFixed || isEmailDisabled}
                dataTestId='primaryEmailInput'
              />
            </div>
            {confirmEmailAddress &&
              <div className='col-xs-12 col-md-4'>
                <Input
                  name={`${prefix}emailAgain`}
                  label='Email again'
                  intlKey='label.email_again'
                  disabled={isEmailFixed}
                  dataTestId='primaryEmailInputAgain'
                />
              </div>}
          </div>

        {showSecondaryFields && showSecondaryEmail &&
          <div className='row'>
            <div className='col-xs-12 col-md-4'>
              <Input
                name={`${prefix}secondaryEmail`}
                label='Secondary Email'
                intlKey='label.secondary_email'
                autoComplete='new-password'
              />
            </div>
            <div className='col-xs-12 col-md-4'>
              <Input
                name={`${prefix}secondaryEmailAgain`}
                label='Email again'
                intlKey='label.secondary_email_again'
              />
            </div>
          </div>}

        {showOtherEmails &&
          <div className='row'>
            <div className='col-xs-12 col-md-4'>
              <Input
                name={`${prefix}secondaryEmail`}
                label='Secondary Email'
                intlKey='label.secondary_email'
                autoComplete='new-password'
              />
            </div>
            <div className='col-xs-12 col-md-4'>
              <Input
                name={`${prefix}tertiaryEmail`}
                label='Tertiary Email'
                intlKey='label.tertiary_email'
                autoComplete='new-password'
              />
            </div>
          </div>}

        {(showPhoneNumber || showPhoneType) && <div className='row'>
          {showPhoneNumber &&
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <InputPhone
                name={`${prefix}phoneNumber`}
                label='Phone number'
                intlKey='label.phone_number'
                selectedCountryIcoCode={selectedCountryIcoCode}
                dataTestId='primaryPhoneInput'
              />
            </div>}
          {showPhoneType &&
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <Select
                name={`${prefix}phoneType.value`}
                label='Phone type'
                intlKey='label.phone_type'
                options={this.props.phoneTypes}
                dataTestId='primaryPhoneInputType'
              />
            </div>}
        </div>}

        {showSecondaryFields &&
          <div className='row'>
            {showSecondaryPhone && <div className='col-xs-12 col-sm-6 col-md-4'>
              <InputPhone
                name={`${prefix}secondaryPhoneNumber`}
                label='Secondary phone number'
                intlKey='label.secondary_phone_number'
                selectedCountryIcoCode={selectedCountryIcoCode}
              />
            </div>}
            {showSecondaryPhoneType && <div className='col-xs-12 col-sm-6 col-md-4'>
              <Select
                name={`${prefix}secondaryPhoneType.value`}
                label='Secondary phone type'
                intlKey='label.secondary_phone_type'
                options={this.props.phoneTypes}
              />
            </div>}
          </div>}
      </div>
    )
  }
}
